module.exports = "mutation UpdateGuest ($userId: Int!, $user: UserInput!) {\n  updateUser(userId: $userId, user: $user) {\n    id\n  }\n}\n"